import styles from "@/components/modal/license-limited-modals/styles/license-limited-modal.module.scss";

import React, { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import IncreaseLimitsButton from "@/components/common/increase-limits-button";
import { LicenseName } from "@/data/license.data";
import GetFreeAccessButton from "@/components/common/get-free-access-button";

export interface LicenseLimitedHigherPlanConfig {
  serviceName: string;
  isAvailableInHigherPlan: boolean;
}
export interface LicenseLimitedModalPropsBase {
  licenseName: LicenseName;
}

export interface LicenseLimitedModalProps extends LicenseLimitedModalPropsBase {
  allowsMessage: string;
  upgradeToMessage: string;
  shouldNavigateToPricing?: boolean;
  availableInHigherPlanConfig?: LicenseLimitedHigherPlanConfig;
}

const LicenseLimitedModal = ({
  allowsMessage,
  upgradeToMessage,
  licenseName,
  shouldNavigateToPricing,
  availableInHigherPlanConfig,
}: LicenseLimitedModalProps) => {
  const { hideModal } = useGlobalModalContext();
  const router = useRouter();

  useEffect(() => {
    if (shouldNavigateToPricing) {
      router.push("/pricing");
    }
  }, [router, shouldNavigateToPricing]);

  return (
    <div className={styles.trial_modal}>
      <div className={styles.main_text}>
        Thank you for using <br /> {licenseName.toLowerCase()} version of
        AudioModify!
      </div>
      <div className={styles.sub_container}>
        <div>{allowsMessage}</div>
        {availableInHigherPlanConfig?.isAvailableInHigherPlan ? (
          <div>
            {availableInHigherPlanConfig.serviceName} is not available in your
            current plan
          </div>
        ) : (
          <div>
            You have reached the limit for the {licenseName.toLowerCase()}{" "}
            version of our app!
          </div>
        )}
      </div>

      <div className={styles.please_upgrade}>
        Please upgrade to the {licenseName === "Trial" ? "paid" : "higher"}{" "}
        version to {upgradeToMessage} and more!
        <br />
        25% off only today with discount code &quot;cover&quot;
        <br />
      </div>
      <GetFreeAccessButton />
      <IncreaseLimitsButton filled={true} onClick={hideModal} />
    </div>
  );
};

export default LicenseLimitedModal;
